import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import {
  CreateChannelT,
  OneChannelT,
  UpdateChannelT,
  TemplateT,
  ChannelTypeT,
  ByttonType,
  CreateBotAnswerT, BotAnswerT, BotAnswerType,
  TemplateFormValuesT
} from 'shared/api/types/channels'
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';
import { capitalizeFirst } from "../utils/formattings";

initDefaultSchema();

const channelTypes: ChannelTypeT[] = ['push', 'message', 'default', 'welcome'];

const buttonTypes: ByttonType[] = ['inlineKeyboard', 'keyboard'];

const botAnswerTypes: BotAnswerType[] = ['push', 'default'];

export const channelTypeOptions = channelTypes.map((type) => ({
  value: type,
  label: type,
}))

export const buttonTypeOptions = buttonTypes.map((type) => ({
  value: type,
  label: type,
}))

export const botAnswerTypeOptions = botAnswerTypes.map((type) => ({
  value: type,
  label: capitalizeFirst(type),
}))

// Create Template
export type CreateTemplateFormT = TemplateFormValuesT;
export const getCreateChannelTemplateValues = (values?: TemplateT): CreateTemplateFormT => ({
  afterTime: values?.afterTime ?? 0,
  message: values?.message ?? '',
  files: [] as unknown as FileList,
  type: values?.type ?? 'push',
  buttons: values?.buttons ?? [],
});

const createTemplateSchema: Yup.ObjectSchema<CreateTemplateFormT> = Yup.object({
  afterTime: Yup.number().required(),
  files: Yup.array() as FixMeLater,
  message: Yup.string().optional(),
  type: Yup.string().required(),
  buttons: Yup.array()
    .of(
      Yup.object().shape({
        text: Yup.string(),
      })
    ) as FixMeLater
});
export const createTemplateResolver = yupResolver(createTemplateSchema) as Resolver<CreateTemplateFormT>;

export type CreateChannelFormT = CreateChannelT['request'];
export const getCreateChannelValues = (): CreateChannelFormT => ({
  name: '',
});
const createChannelSchema: Yup.ObjectSchema<CreateChannelFormT> = Yup.object({
  name: Yup.string().required(),
});
export const createChannelResolver = yupResolver(createChannelSchema) as Resolver<CreateChannelFormT>;


// Create Bot Answer

export type CreateBotAnswerFormT = Omit<CreateBotAnswerT['request'], 'sourceType'>;
export const getCreateBotAnswerValues = (values?: BotAnswerT): CreateBotAnswerFormT => ({
  pushId: values?.pushId ?? '',
  sourceId: values?.sourceId ?? '',
  type: values?.type ?? 'default',
  message: values?.message ?? '',
  isActive: values?.isActive ?? false
});

const createBotAnswerSchema: Yup.ObjectSchema<CreateBotAnswerFormT> = Yup.object({
  pushId: Yup.string().required(),
  sourceId: Yup.string(),
  type: Yup.string().required(),
  message: Yup.string(),
  isActive: Yup.boolean().required(),
});
export const createBotAnswerResolver = yupResolver(createBotAnswerSchema) as Resolver<CreateBotAnswerFormT>;


// Update Channel
export type UpdateChannelFormT = UpdateChannelT['request'];
export const getUpdateChannelValues = (values?: OneChannelT['response']): UpdateChannelFormT => ({
  name: values?.name ?? '',
});
const updateChannelSchema: Yup.ObjectSchema<UpdateChannelFormT> = Yup.object({
  name: Yup.string().required(),
});
export const updateChannelResolver = yupResolver(updateChannelSchema) as Resolver<UpdateChannelFormT>;
